<template>
  <div class="container-fluid m-3">
    <h2>Tabellen Editor</h2>
    <b-tabs>
      <b-tab title="Schema">
        <div class="btn-toolbar mt-3" role="toolbar">
          <button @click="saveSchema" class="btn btn-primary">Speichern</button>
          <button @click="deleteTableAndSchema" class="btn btn-danger">Löschen</button>
        </div>
        <div class="row mt-3">
          <h3>Tabelle</h3>
          <div class="col">
            <div class="form-group">
              <label>Tabellen Key</label>
              <input type="text" class="form-control" v-model="table.tableId"/>
            </div>
            <div class="form-group">
              <label>Beschreibung</label>
              <textarea class="form-control" rows="3" v-model="table.description">
              </textarea>
            </div>
            <div class="form-group">
              <label>Besizer: {{ sysuser[table.owner] ? sysuser[table.owner].userKey : table.owner }}</label>
            </div>
            <h4>Zugriffsrechte</h4>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label>Benutzer</label>
                  <select class="form-control" v-model="acl.user">
                    <option v-for="u in sysuser" :key="u.id" :value="u.id">{{ u.userKey }}</option>
                  </select>
                </div>
              </div>
              <div class="col">
                <label>Rechte</label>
                <div class="form-check">
                  <label><input type="checkbox" v-model="acl.read" class="form-check-input"/>Lesen</label>
                </div>
                <div class="form-check">
                  <label><input type="checkbox" v-model="acl.write" class="form-check-input"/>Schreiben</label>
                </div>
                <button @click="addACL" class="btn btn-primary">Übernehmen</button>
              </div>
            </div>
            <ul class="list-group mt-3">
              <li v-for="(acl,index) in table.acls" :key="index" class="list-group-item d-flex justify-content-between">
                <span>{{ sysuser[acl.user] ? sysuser[acl.user].userKey : acl.user }}</span>
                <div><span v-for="(a,index) in acl.actions" :key="index">{{ a }}</span></div>
                <button class="btn btn-danger"><font-awesome-icon @click="deleteACL(index)" icon="trash"/></button>
              </li>
            </ul>
          </div>
          <div class="col">
            <h3>Spalten</h3>
            <div class="btn-toolbar m-2" role="toolbar">
              <button @click="addColumn" class="btn btn-primary"><strong>+</strong></button>
            </div>
            <ul class="list-group">
              <li v-for="(c,index) in table.columns" :key="index" class="list-group-item">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                        <label>Name:</label><input type="text" class="form-control" v-model="c.name"/>
                    </div>
                    <div class="form-inline">
                        <input type="checkbox" class="form-check" v-model="c.indexed"/><label>Indiziert</label>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-group">
                        <label>Type:</label>
                        <select class="form-control" v-model="c.dataType">
                          <option value="string">Text</option>
                          <option value="long">Ganzzahl</option>
                          <option value="double">Zahl</option>
                          <option value="timestamp">Zeitstempel / Datum</option>
                          <option value="boolean">Boolean</option>
                          <option value="jsonobj">JSON Object</option>
                          <option value="jsonarray">JSON Array</option>
                        </select>
                    </div>
                    <div class="form-inline">
                        <input type="checkbox" class="form-check" v-model="c.idColumn"/><label>ID Wert</label>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </b-tab>
      <b-tab title="Daten">
        <div class="btn-toolbar m-3 d-flex justify-content-between" role="toolbar">
          <div class="btn-group">
            <button @click="prevPage" class="btn btn-secondary"><font-awesome-icon icon="chevron-left"/></button>
            <button @click="nextPage" class="btn btn-secondary"><font-awesome-icon icon="chevron-right"/></button>
          </div>
          <button @click="addRow" class="btn btn-primary"><strong>+</strong></button>
        </div>
        <table class="table table-striped">
          <thead>
            <tr>
              <th v-for="(c,index) in table.columns" :key="index">
                {{ c.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,index) in tabledata" :key="index">
              <td v-for="(c,index) in table.columns" :key="index">
                {{ row[c.name] }}
              </td>
              <td>
                <button @click="openRow(row)" class="btn btn-primary"><font-awesome-icon icon="edit"/></button>
                <button @click="deleteRow(row)" class="btn btn-secondary"><font-awesome-icon icon="trash"/></button>
              </td>
            </tr>
          </tbody>
        </table>
        <b-modal id="rowEditor" title="Eintrag Editor" ok-title="Speichern" @ok="saveRow" >
          <div class="container">
            <div v-for="(c,index) in table.columns" :key="index" class="form-group">
              <label>{{ c.name }}</label>
              <input v-if="c.dataType=='long' || c.dataType == 'double' || c.dataType == 'integer'" type="number" class="form-control" v-model.number="editRow[c.name]"/>
              <input v-else-if="c.dataType == 'boolean'" type="checkbox" class="form-control" v-model="editRow[c.name]"/>
              <input v-else type="text" class="form-control" v-model="editRow[c.name]"/>
            </div>
          </div>
        </b-modal>
      </b-tab>
      <b-tab title="Synchronisation">
        <div class="btn-toolbar d-flex justify-content-between mt-3" role="toolbar">
          <button @click="saveSyncInfo" class="btn btn-primary">Übernehmen</button>
          <button @click="startTableSync" class="btn btn-secondary">Starten</button>
          <button @click="deleteSyncInfo" class="btn btn-danger">Löschen</button>
        </div>
        <div class="row mt-3">
          <div class="col">
            <div class="form-group">
              <label><strong>Datenquelle</strong></label>
              <select v-model="syncinfo.syncsource" class="form-control">
                <option v-for="t in systables" :key="t.name" :value="t.name">{{ t.name }}</option>
              </select>
            </div>
          </div>
          <div class="col">
            <h5>Zeitliche Planung</h5>
            <CronExprBuilder ref="cron"/>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import tables from '@/modules/tables.js'
import datamap from '@/modules/datamap.js'
import sysuser from '@/modules/sysuser.js'
import CronExprBuilder from '@/components/CronExprBuilder.vue'

export default {
  components: {
    CronExprBuilder,
  },
  data() {
    return {
      acl: {},
      syncinfo: { syncsource: '' },
      systables: [],
      sysuser: {},
      table: { columns: [] },
      tabledata: [],
      start: 0,
      count: 25,
      editRow: {},
      idKey: false,
    }
  },
  created() {
    var self = this;
    datamap.listtables(this,0,500,'name','',function(data) {
      self.systables = data;
    })

    if (this.$route.params.id !== 'new') {
      this.loadSchema();
    }
    sysuser.list(function(data) {
      data.forEach((e) => {
        self.sysuser[e.id] = e;
      });
      console.log('sysuser',self.sysuser);
    })
  },
  methods: {
    deleteACL(idx) {
      if (this.table.acls.length > idx) {
        this.table.acls.splice(idx,1);
      }
    },
    addACL() {
      console.log('add acl',this.acl);
      var entry = { user: this.acl.user, actions: [] };
      if (this.acl.read) {
        entry.actions.push('r');
      }
      if (this.acl.write) {
        entry.actions.push('w');
      }
      var added = false;
      for (var idx in this.table.acls) {
        if (this.table.acls[idx].user == entry.user) {
          added = true;
          this.table.acls[idx] = entry;
          break;
        }
      }
      if (!added) {
        this.table.acls.push(entry);
      }
    },
    saveSyncInfo() {
      this.syncinfo.extratable = this.table.tableId;
      this.syncinfo.cron = this.$refs.cron.cron;

      var self = this;
      tables.saveTableSyncInfo(this.table.tableId,this.syncinfo).then(function(data) {
        self.$bvToast.toast('Synchronisations Einstellungen übernommen.',{title: 'Synchronisation',variant: 'success'});
        self.syncinfo = data;
      })
    },
    loadSyncInfo() {
      var self = this;
      tables.listTableSyncInfos(this.table.tableId).then(function(data) {
        console.log('sync info',data);
        if (data && data.length > 0) {
          self.syncinfo = data[0];
          self.$refs.cron.cron = data[0].cron;
        }
      });
    },
    deleteSyncInfo() {
      tables.deleteTableSyncInfo(this.syncinfo.id).then(function() {
        self.$bvToast.toast('Planung gelöscht.',{variant: 'success',title:'Synchronisation'});
      });
    },
    startTableSync() {
      console.log('start table sync');
      var self = this;
      tables.startTableSync(this.table.tableId,this.syncinfo.id).then(function() {
        self.$bvToast.toast('Synchronisation gestartet',{variant:'success',title:'Tabelle'});
      });
    },
    getIDKey(force = false) {
      if (this.idKey && !force) return this.idKey;
      for (var c in this.table.columns) {
        var col = this.table.columns[c];
        if (col.idColumn) this.idKey = col.name;
      }
      return this.idKey;
    },
    addColumn() {
      var col = { name: 'Spalte' + this.table.columns.length, dataType: 'string', idColumn: false, indexed: false };
      this.table.columns.push(col);
    },
    loadSchema() {
      var self = this;
      tables.loadTableSchema(this.$route.params.id).then(function(data) {
        self.table = data;
        self.getIDKey(true);
        self.loadData();
        self.loadSyncInfo();
      })
    },
    addRow() {
      this.editRow = {};
      this.$bvModal.show('rowEditor');
    },
    openRow(item) {
      console.log(item);
      this.editRow = item;
      this.$bvModal.show('rowEditor');
    },
    saveRow() {
      console.log('save',this.editRow);
      var self = this;
      tables.saveTableData(this.table.tableId,[this.editRow]).then(function() {
        self.$bvToast.toast('Eintrag gespeichert',{variant:'success',title: 'Tabelleneintrag'})
        self.loadData();
      });
    },
    deleteRow(row) {
      if (!confirm('Möchten Sie den Eintrag wirklich löschen?')) {
        return;
      }
      console.log('delete',row);
      var self = this;
      var keyCol = this.getIDKey();
      if (!keyCol) {
        this.$bvToast.toast('Keine ID Spalte hinterlegt',{variant: 'danger', title: 'Tabelle Zeilen'});
        return;
      }
      var filter = {};
      filter[keyCol] = { "equals": row[keyCol] };
      tables.deleteTableRows(this.table.tableId,filter,false).then(function() {
        self.loadData();
      })
    },
    loadData() {
      console.log('load page: ',this.start,this.count,this.getIDKey());
      var self = this;
      tables.queryTableData(this.table.tableId,this.start,this.count,false,this.getIDKey()).then(function(data) {
        self.tabledata = data;
      });
    },
    saveSchema() {
      var self = this;
      tables.saveTableSchema(this.table).then(function(data) {
        self.$bvToast.toast('Schema gespeichert',{ variant: 'success', title: 'Tabellen Schema'});
        self.getIDKey(true);
        self.table = data;
      }).catch(function(err) {
        console.log(err);
        self.$bvToast.toast('Speichern fehlgeschlagen: ' + err,{variant: 'danger', title: 'Tabellen Schema'});
      })
    },
    deleteTableAndSchema() {
      console.error('Not implemented yet');
    },
    nextPage() {
      this.start += 25;
      this.loadData();
    },
    prevPage() {
      if (this.start >= 25) {
        this.start -= 25;
        this.loadData();
      }
    },
  }
}
</script>
